import {AfterContentInit, Directive, ElementRef, Renderer2} from '@angular/core';

@Directive({
    selector: 'ion-content'
})

export class ModalMarginDirective implements AfterContentInit {

    ajustaModalTO = 0;

    constructor(public element: ElementRef, public renderer: Renderer2) {

    }

    ngAfterContentInit() {

        setTimeout(() => this.ajustaModal(), 20);
        this.ajustaModalTO = setInterval(() => this.ajustaModal(), 200);

    }

    ajustaModal() {

        const ionModalContent = this.element.nativeElement;
        const ionModalWrapper = ionModalContent.parentElement.parentElement;

        if (!ionModalWrapper || ionModalWrapper.parentElement.className.indexOf('modal-margin') === -1) {
            clearInterval(this.ajustaModalTO);
            return;
        }

        let ionModalHeader = ionModalContent.parentElement.children[0];
        let ionModalFooter = ionModalContent.parentElement.children[ionModalContent.parentElement.children.length - 1];
        const ionModalContentInners = ionModalContent.children[1].children;

        let height: number = 0;

        if (ionModalHeader.tagName === 'ION-HEADER') height += ionModalHeader.offsetHeight;
        else ionModalHeader = null;

        if (ionModalFooter.tagName === 'ION-FOOTER') height += ionModalFooter.offsetHeight;
        else ionModalFooter = null;

        for (const i in ionModalContentInners) {
            if (!ionModalContentInners[i].offsetHeight) continue;
            this.renderer.setStyle(ionModalContentInners[i], 'overflow', 'hidden');
            height += ionModalContentInners[i].offsetHeight;
        }

        if (ionModalHeader && height === ionModalHeader.offsetHeight) height += 200;
        if (ionModalFooter && height === ionModalFooter.offsetHeight) height += 200;
        if (!height) height += 200;

        this.renderer.setStyle(ionModalWrapper, 'height', height + 'px');

    }

}



// WEBPACK FOOTER //
// ./src/directives/modal-margin.ts